import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _MapConstructionStatu;
import { EConstructionStatus } from '../../types/newbuilding-mvk';
import { plural, numberToPrettyString } from '@cian/utils';
import { getSectionHintLayout } from '../../components/map/section_hint';
import { MVKPolygonType } from '../../types/mvk_map';
import { QUARTER_MAP } from '../parsers/houses';
var MIDDLE_POINT = "\xB7";

// прозрачность для полигонов
export var STYLE_PROPS = {
  hoveredOpacity: 0.8,
  opacity: 0.2
};

// статусы строительства дома
export var ConstructionStatus = {
  FINISHED: EConstructionStatus.Finished,
  IN_PROGRESS: EConstructionStatus.InProgress,
  IN_PROJECT: EConstructionStatus.InProject
};

// цвета статусов строительства
export var MapConstructionStatusToPolygonColorHex = (_MapConstructionStatu = {}, _defineProperty(_MapConstructionStatu, ConstructionStatus.FINISHED, '2e9e00'), _defineProperty(_MapConstructionStatu, ConstructionStatus.IN_PROGRESS, 'ff9d00'), _defineProperty(_MapConstructionStatu, ConstructionStatus.IN_PROJECT, '7a7a7a'), _MapConstructionStatu);
export function createSectionPolgonParams(section, house, offers, ymaps) {
  var hintData = getSectionHintData(section, house, offers);
  var hintSectionLayout = hintData && getSectionHintLayout(hintData);
  return {
    points: section.polygon.coordinates[0][0],
    props: {
      cursor: 'pointer',
      fillColor: "#".concat(MapConstructionStatusToPolygonColorHex[house.constructionStatus]),
      fillOpacity: STYLE_PROPS.opacity,
      hintCloseTimeout: 0,
      hintLayout: ymaps.templateLayoutFactory.createClass(hintSectionLayout),
      hintOffset: [-130, -120],
      hintOpenTimeout: 0,
      houseId: house.id,
      id: section.id,
      outline: false,
      type: MVKPolygonType.SECTION
    }
  };
}
function getSectionHintData(section, house, offers) {
  var flats = offers.filter(function (_ref) {
    var flatNumber = _ref.flatNumber,
      sectionNumber = _ref.sectionNumber,
      houseId = _ref.houseId,
      floor = _ref.floor;
    var isSectionFlat = houseId === house.id && sectionNumber === section.number;
    return isSectionFlat && section.floorPlans.some(function (plan) {
      return plan.floors.includes(floor) && plan.floorPlanFlats.some(function (planFlat) {
        return planFlat.flatNumber === flatNumber;
      });
    });
  });
  var deadLine;
  var constructionStatus = house.constructionStatus;
  if (constructionStatus === ConstructionStatus.FINISHED) {
    deadLine = 'Сдан';
  } else {
    var year = 0;
    var quarter = 0;
    flats.forEach(function (flat) {
      if (flat.deadlineYear && flat.deadlineYear > year) {
        year = flat.deadlineYear;
        if (flat.deadlineQuarter) {
          quarter = Math.max(quarter, QUARTER_MAP[flat.deadlineQuarter]);
        }
      }
    });
    deadLine = "\u0421\u0434\u0430\u0447\u0430 \u0432 ".concat(quarter, " \u043A\u0432. ").concat(year);
  }
  var flatTypeText = getFlatTypeText(flats);
  var minPrice = flats.reduce(function (price, flat) {
    return price && price < flat.price ? price : flat.price;
  }, 0);
  return {
    deadLine: deadLine,
    name: house.sections.length === 1 ? house.name : "".concat(house.name, " ").concat(MIDDLE_POINT, " \u0441\u0435\u043A\u0446\u0438\u044F ").concat(section.number),
    pricingInfo: "".concat(flats.length, " ").concat(flatTypeText, " \u043E\u0442 ").concat(numberToPrettyString(minPrice), " \u20BD")
  };
}

// возвращает стили и координаты точек для полигона ЖК
export function getColoredNewbuildingPolygon(newbuildingPolygon) {
  return {
    points: newbuildingPolygon.coordinates[0][0],
    props: {
      cursor: 'default',
      fillColor: 'rgb(4, 104, 255)',
      fillOpacity: 0.15,
      fillStyleHex: '2b87db26',
      lineCap: 'round',
      strokeColor: 'rgb(4,104,255)',
      strokeOpacity: 0.6,
      strokeStyleHex: '256ba599',
      strokeWidth: 2,
      type: MVKPolygonType.NEWBUILDING,
      zIndex: 0
    }
  };
}

// создает координаты точек для полигона на карте
export function getCoordinatesFromPoints(points) {
  return [points.map(function (point) {
    return [point[0], point[1]];
  })];
}

// опции для создания геообъекта карты
export function getYmapsPolygonGeometryOptions(polygon) {
  return {
    geometry: {
      coordinates: getCoordinatesFromPoints(polygon.points),
      type: 'Polygon'
    }
  };
}

// фильтрует дома с полигонами и секциями
export function getHousesWithSections(houses) {
  return houses.filter(function (_ref2) {
    var sections = _ref2.sections;
    return Array.isArray(sections) && sections.length;
  });
}
export function setHoverOpacityToPolygon(target, isHovered) {
  target.options.set({
    fillOpacity: isHovered ? STYLE_PROPS.hoveredOpacity : STYLE_PROPS.opacity
  });
}
export function createPolygonParams(points) {
  return points.map(function (point) {
    return "".concat(point[0], ",").concat(point[1]);
  }).join(',');
}

// ссылка на картинку карты яндекс, с расположением секции дома
export function createStaticMapImageUrlOfferPhase(size, house, section) {
  if (!house || !section) {
    return '';
  }
  var color = MapConstructionStatusToPolygonColorHex[house.constructionStatus];
  var houseColor = "".concat(color, "88"); // цвет с прозрачностью
  var housePolygon = createPolygonParams((house.polygon || section.polygon).coordinates[0][0]);
  var sectionPolygon = createPolygonParams(section.polygon.coordinates[0][0]);
  return "https://static-maps.yandex.ru/1.x/?z=16&l=map" + "&size=".concat(size[0] * 2, ",").concat(size[1]) + "&pl=f:".concat(houseColor, ",w:0,").concat(housePolygon, "~f:").concat(color, ",w:0,").concat(sectionPolygon);
}

// Параметры для картинки расположения квартиры на этаже
export function getFloorPlanPolygonParams(canvasSize, polygonPoints) {
  var round = Math.round,
    max = Math.max;
  var floorPlanImageSize = [2000, 2000];
  if (polygonPoints && polygonPoints.length > 0) {
    var points = polygonPoints.reduce(function (acc, point) {
      return acc.concat(point);
    }, []);
    var initValue = [[points[0][0], points[0][1]], [points[0][0], points[0][1]]];
    var _points$reduce = points.reduce(function (_ref3, point) {
        var _ref4 = _slicedToArray(_ref3, 2),
          _ref4$ = _slicedToArray(_ref4[0], 2),
          mnX = _ref4$[0],
          mnY = _ref4$[1],
          _ref4$2 = _slicedToArray(_ref4[1], 2),
          mxX = _ref4$2[0],
          mxY = _ref4$2[1];
        return [[point[0] < mnX ? point[0] : mnX, point[1] < mnY ? point[1] : mnY], [point[0] > mxX ? point[0] : mxX, point[1] > mxY ? point[1] : mxY]];
      }, initValue),
      _points$reduce2 = _slicedToArray(_points$reduce, 2),
      _points$reduce2$ = _slicedToArray(_points$reduce2[0], 2),
      minX = _points$reduce2$[0],
      minY = _points$reduce2$[1],
      _points$reduce2$2 = _slicedToArray(_points$reduce2[1], 2),
      maxX = _points$reduce2$2[0],
      maxY = _points$reduce2$2[1];
    floorPlanImageSize = [round(maxX + minX), round(maxY + minY)];
  }
  var _floorPlanImageSize = floorPlanImageSize,
    _floorPlanImageSize2 = _slicedToArray(_floorPlanImageSize, 2),
    drawnImageWidth = _floorPlanImageSize2[0],
    drawnImageHeight = _floorPlanImageSize2[1];
  var scale = max(drawnImageWidth / canvasSize[0], drawnImageHeight / canvasSize[1]);
  var _map = [0, 0].map(function (pad, index) {
      var imageSize = round(floorPlanImageSize[index] / scale);
      return imageSize < canvasSize[index] ? round(canvasSize[index] - imageSize) / 2 : pad;
    }),
    _map2 = _slicedToArray(_map, 2),
    offsetLeft = _map2[0],
    offsetTop = _map2[1];
  return {
    drawnImageHeight: drawnImageHeight,
    drawnImageWidth: drawnImageWidth,
    imageContainerHeight: round(drawnImageHeight / scale),
    imageContainerWidth: round(drawnImageWidth / scale),
    offsetLeft: offsetLeft,
    offsetTop: offsetTop
  };
}
export function getFlatTypeText(flats) {
  var withApartments = false; // есть апартаменты
  var withFlats = false; // есть квартиры
  var result = '';
  flats.forEach(function (flat) {
    if (flat.isApartments) {
      withApartments = true;
    } else {
      withFlats = true;
    }
  });
  if (withApartments && withFlats) {
    result = 'кв. и апарт.';
  } else if (withApartments) {
    result = plural(flats.length, ['апартамент', 'апартамента', 'апартаментов']);
  } else if (withFlats) {
    result = plural(flats.length, ['квартира', 'квартиры', 'квартир']);
  }
  return result;
}